module.exports = __webpack_public_path__ + "img/bs_plus_shop_soon_de-DE.b477ce37.jpg";